import script from './component-lib.esm68.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    staticClass: "icon-muso",
    attrs: {
      "viewBox": "0 0 166 128"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Muso'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M165.689 100.81c.026-12.268.03-24.537.034-36.81V63.949c0-12.27-.008-24.538-.034-36.81-.004-2.411.127-4.836.037-7.25v-.038c0-.045-.007-.086-.007-.13-.008-.165-.015-.33-.026-.494a19.854 19.854 0 00-.508-3.913c-.03-.134-.049-.265-.079-.4a3.994 3.994 0 00-.146-.478C162.602 6.11 154.96 0 145.875 0c-5.557 0-10.572 2.287-14.174 5.964-8.121 7.437-29.736 29.912-46.859 47.173a2.763 2.763 0 01-3.92 0C63.762 35.846 42.016 13.25 33.902 5.826a20.85 20.85 0 00-1.752-1.543c-.449-.374-.8-.636-1.05-.785A19.772 19.772 0 0019.855 0C14.096 0 8.928 2.466 5.303 6.38c-1.977 1.957-3.37 4.342-4.238 7.103A19.766 19.766 0 000 19.855c0 .157.078 5.019.071 7.287C.045 39.411.041 51.68.037 63.952v.052c0 8.977.02 43.821.023 57.969a6.023 6.023 0 006.028 6.021 6.028 6.028 0 006.028-6.028l.003-101.494c0-3.809 2.934-7.127 6.742-7.243a6.952 6.952 0 017.168 6.951l.003 80.227a4.557 4.557 0 004.56 4.555 4.558 4.558 0 004.559-4.559V44.048c0-3.808 2.933-7.13 6.741-7.242a6.952 6.952 0 017.168 6.951l.022 33.529a4.649 4.649 0 009.298-.004l-.004-20.868c0-2.455 2.964-3.692 4.705-1.962 15.154 15.03 62.065 61.523 68.62 67.529 3.602 3.677 8.621 5.964 14.174 5.964 9.085 0 16.727-6.11 19.089-14.44.06-.164.108-.325.146-.478.033-.135.052-.266.078-.4.296-1.263.467-2.571.509-3.913.007-.164.018-.329.026-.493 0-.045.007-.086.007-.131v-.037c.086-2.407-.045-4.832-.041-7.243zm-58.305-29.317c0 2.463-2.975 3.696-4.716 1.955l-7.52-7.52a2.763 2.763 0 010-3.908l7.52-7.519c1.741-1.741 4.716-.508 4.716 1.954v15.038zm23.225 12.9a6.953 6.953 0 01-6.954 6.955 6.954 6.954 0 01-6.955-6.954V43.559a6.954 6.954 0 016.955-6.955 6.953 6.953 0 016.954 6.955v40.835zm23.028 23.581a6.954 6.954 0 01-6.955 6.955 6.954 6.954 0 01-6.954-6.955V19.978a6.954 6.954 0 016.954-6.954 6.954 6.954 0 016.955 6.954v87.996z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-4a4074c9_0", {
    source: ".icon-muso[data-v-4a4074c9]{width:1.2em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-4a4074c9";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var MusoIcon = __vue_component__;
export { MusoIcon as default };